<template>
  <button class="helper-btn" :disabled="disabled" :class="size ? `helper-btn--${size}` : ''">
    <component v-if="icon" :is="icon" :fill="fill" />
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'HelperBtn',
  props: {
    icon: {
      type: String,
      default: null
    },
    fill: {
      type: String,
      default: '#ffffff'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .helper-btn {
    background-color: #A217AB;
    border: 0;
    outline: 0;
    width: 3em;
    height: 3em;
    display: flex;
    cursor: pointer;
    border-radius: 9999px;
    transition: all 100ms;
    >* {
      margin: auto
    }
    &--sm {
      font-size: 10px;
    }
    &:hover {
      &:hover {
        background: #CE3ED1;
      }
      &:active {
        background: #830486
      }
    }
  }
</style>
